<template>
    <div class="bread-box">
        <a-breadcrumb>
            <a-breadcrumb-item v-for="str in breadcrumbList" :key="str">{{str}}</a-breadcrumb-item>
        </a-breadcrumb>
    </div>
</template>
<script>
    export default {
        props:{
            breadcrumbList:{
                type:Array,
                default:['首页']
            },
        },
        data() {
            return {}
        },
        methods: {},
        created() {
        },
    }
</script>
<style lang="less">
    @gray-color:rgba(0,0,0,0.45);
    @font-14:14px;
    div.bread-box{
        padding:16px 32px 0 32px;
        width:100%;
        background-color: #fff;
        text-align: left;
        h3{
            margin: 0;
            margin-top:16px;
            font-family: '微软雅黑';
            font-weight: bold;
            font-size: 20px;
        }
        div.index-show{
            display: flex;
            align-items: center;
            padding: 16px 0;
            &-left{
                display: flex;
                align-items: center;
                img{
                    width: 96px;
                    height: 96px;
                    border-radius: 8px;
                    margin-right: 16px;
                }
                div.shop-name-notice{
                    p.notice{
                        font-size: @font-14;
                        color: @gray-color;
                        margin-top: 10px;
                        margin-bottom: 0;
                    }
                    p.qr-code{
                        display: flex;
                        align-items: center;
                        margin-bottom: 0;
                        img{
                            width: 20px;
                            height: 20px;
                            margin-right: 5px;
                        }
                        span{
                            font-size: 12px;
                            color:rgba(0,0,0,0.45);
                        }
                    }
                }
            }
            &-right{
                flex: 1;
                ul{
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    li{
                        display: flex;
                        flex-direction: column;
                        padding: 0 30px;
                        border-right: 1px solid #E9E9E9;
                        &:last-child{
                            border: 0;
                            padding-right: 0;
                        }
                        &:first-child{
                            padding-left: 0;
                        }
                        >h3{
                            font-size: 30px;
                            font-weight: 500;
                        }
                        >p{
                            color: @gray-color;
                            font-size: @font-14;
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }
    }
</style>